import { Badge } from '@/components/ui/badge'
import { type EmailTemplate } from '@/models/emailTemplate'

interface TemplateScopeNoteProps {
  template: EmailTemplate
  canManage: boolean
}

const LINE = 'text-muted-foreground flex items-center gap-2 text-sm'

/** Who sees this template, so an edit to a shared or teammate's one isn't a surprise. */
export function TemplateScopeNote({ template, canManage }: TemplateScopeNoteProps) {
  if (template.isGlobal) {
    return (
      <p className={LINE}>
        <Badge variant="secondary">Global</Badge>
        Everyone on the team can use and edit this template.
      </p>
    )
  }
  if (canManage) {
    return (
      <p className={LINE}>
        <Badge variant="outline">Personal</Badge>
        Only you can pick this template when writing an email or text.
      </p>
    )
  }
  return (
    <p className={LINE}>
      <Badge variant="outline">{template.owner.name}</Badge>
      This is {template.owner.name}’s template. Your edits change it for them.
    </p>
  )
}
